export default "__VITE_ASSET__1e748366__"